module.exports = __webpack_public_path__ + "static/2-ebde906cab865fadd631b8d76376c415.svg";